// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"5f1234be","135":"b10cfc26","150":"a9fd8c73","226":"bde93eea","355":"6b64bd8d","482":"8b9def6c"}[chunkId] + ".chunk.js";
};